import React, { Component } from "react"
import Button from "@material-ui/core/Button"
import FormControlLabel from "@material-ui/core/FormControlLabel"
import { Link } from "react-router-dom"
import Grid from "@material-ui/core/Grid"
import Typography from "@material-ui/core/Typography"
import Container from "@material-ui/core/Container"
import { withStyles } from "@material-ui/core"
import { Cookies } from "react-cookie"
import { Alert, AlertTitle } from "@material-ui/lab"
import { Redirect } from "react-router-dom"
import Paper from "@material-ui/core/Paper"
import Table from "@material-ui/core/Table"
import TableBody from "@material-ui/core/TableBody"
import TableCell from "@material-ui/core/TableCell"
import TableContainer from "@material-ui/core/TableContainer"
import TableHead from "@material-ui/core/TableHead"
import TablePagination from "@material-ui/core/TablePagination"
import TableRow from "@material-ui/core/TableRow"
import JDate from "jalali-date"
import Switch from "@material-ui/core/Switch"
import Snackbar from "@material-ui/core/Snackbar"
import { $post } from "./../func";
import Divider from "@material-ui/core/Divider"
import TableSortLabel from "@material-ui/core/TableSortLabel"
import Moment from "moment"
import NumberFormat from "react-number-format"
import HighlightOffIcon from "@material-ui/icons/HighlightOff"

import Collapse from "@material-ui/core/Collapse"
import Avatar from "@material-ui/core/Avatar"
import * as constants from "../constants"
import "react-modern-calendar-datepicker/lib/DatePicker.css"
import Calendar from "react-modern-calendar-datepicker"
import OutlinedInput from "@material-ui/core/OutlinedInput"
import IconButton from "@material-ui/core/IconButton"
import InputAdornment from "@material-ui/core/InputAdornment"
import FloatingLabelInput from "./FloatingLabelInput"
import Fab from "@material-ui/core/Fab"
import VoiceOverOffIcon from "@material-ui/icons/VoiceOverOff"
import RecordVoiceOverIcon from "@material-ui/icons/RecordVoiceOver"
import CloseIcon from "@material-ui/icons/Close"
import CheckIcon from "@material-ui/icons/Check"
import Select from "react-select"

import ImageUploader from "react-images-upload"
import LinearProgress from "@material-ui/core/LinearProgress"

import ReactHTMLTableToExcel from "react-html-table-to-excel"
import { Lightbox } from "react-modal-image"

const styles = (theme) => ({
      paperrtl: {
            marginTop: theme.spacing(0),
            display: "flex",
            flexDirection: "column",
            alignItems: "center",
      },
      paper: {
            display: "flex",
            flexWrap: "wrap",
            "& > *": {
                  margin: theme.spacing(1),
                  width: theme.spacing(20),
            },
      },
      root: {
            width: "100%",
            margin: "15px",
            padding: "8px",
            direction: "rtl",
      },
      container: {
            maxHeight: 400,
      },
      large: {
            width: theme.spacing(10),
            height: theme.spacing(10),
      },
      small: {
            width: theme.spacing(6),
            height: theme.spacing(6),
      },
})

class ChangeReportInstalmentDificitNoPassed extends Component {
      cookies = new Cookies()
      temp333
      constructor(props) {
            super(props)
            this.state = {
                  redirect: false,
                  errstr: "",
                  errstatus: false,
                  okstatus: false,
                  requestinfos: [],
                  requestinfofilter: [],
                  rowsPerPage: 10,
                  page: 0,

                  newFinancialDoc: true,
                  RefundUser: null,
                  orderBy: "instalment_check_id",
                  order: "desc",
                  snackstr: "",
                  showSnack: false,
                  snackMode: "success",

                  refundUserMaxDate: "",
                  refundUserMinDate: "",
                  refundUserMaxAmount: "",
                  refundUserMinAmount: "",
                  checkDatePass: "",
                  checkDocPass: "",

                  refundPayMaxDate: "",
                  refundPayMinDate: "",
                  requestIdFilter: "",

                  urlToLargeImageFile: "",
                  urlToHugeImageFile: "",
                  descImageFile: "",
                  openImageBox: false,
            }
      }

      handleSelectRows = (row2) => {
            this.setState(
                  {
                        RefundUser: row2,
                        newFinancialDoc: false,
                  },
                  () => {}
            )
      }
      newFinancialDoc = (event) => {
            this.setState({
                  RefundUser: null,
                  newFinancialDoc: true,
                  refundUserMaxDate: "",
                  refundUserMinDate: "",
                  refund_user_code: "",
                  refundUserMaxAmount: "",
                  refundUserMinAmount: "",
            })
      }

      setSelectedDayMax = (event) => {
            this.setState({ refundUserMaxDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMax = (event) => {
            this.setState({ refundUserMaxDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDayMin = (event) => {
            this.setState({ refundUserMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearDeyMin = (event) => {
            this.setState({ refundUserMinDate: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedDatePass = (event) => {
            this.setState({ checkDatePass: event }, () => {
                  this.filterList()
            })
      }

      clearDatePass = (event) => {
            this.setState({ checkDatePass: "" }, () => {
                  this.filterList()
            })
      }

      setSelectedPayDayMax = (event) => {
            this.setState({ refundPayMaxDate: event }, () => {
                  this.filterList()
            })
      }

      handleDocPass = (event) => {
            this.setState({ checkDocPass: event.target.value }, () => {})
      }

      setSelectedPayDayMin = (event) => {
            this.setState({ refundPayMinDate: event }, () => {
                  this.filterList()
            })
      }

      clearPayDeyMin = (event) => {
            this.setState({ refundPayMinDate: "" }, () => {
                  this.filterList()
            })
      }

      handleChangeMaxAmount = (event) => {
            this.setState({ refundUserMaxAmount: event }, () => {
                  this.filterList()
            })
      }

      handleChangeMinAmount = (event) => {
            this.setState({ refundUserMinAmount: event }, () => {
                  this.filterList()
            })
      }

      handleClickcloseTasckBar = (event) => {
            this.setState({ showSnack: false })
      }

      handleChangeFilterRequestId = (event) => {
            this.setState({ requestIdFilter: event.target.value }, () => {
                  this.filterList()
            })
      }

      // ------------------------------------------------------------------------------------------------------
    async  componentDidMount() {
            if (this.cookies.get("employee_token_str")) {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })
                  const response = await $post(`employeelogin?command=checkemployeelogin`, {
                        Authorization: this.cookies.get("employee_token_str"),
                      });
                
                      const arr = response.data;
                  var self = this
                  // var xhttp = new XMLHttpRequest()
                  // xhttp.onreadystatechange = function() {
                        if (response.status == 200) {
                              // var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                              } else if (arr.result === "error") {
                                    self.setState({ redirect: true })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })}
                
                  // var fd = new FormData()
                  // fd.append("command", "checkemployeelogin")

                  // xhttp.open("POST", `${constants.BASE_URL}/employeelogin`)
                  // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  // xhttp.send(fd)
            } else {
                  this.setState({ redirect: true })
            }
      }


            // ------------------------------------------------------------------------------------------------------

   async   getFinancialDocPaing() {
            const { rowsPerPage, page } = this.state

            this.props.props.props.dispatch({
                  type: "WAITSHOW",
            })
            var self = this
            const response = await $post(`reportinstallmentpay?command=get_instalment_deficit&report_mode=deficit_notpass&limit=${rowsPerPage}&offset=${page * rowsPerPage}`, {
                  Authorization: this.cookies.get("employee_token_str"),
                });
          
                const arr = response.data;
            // var xhttp = new XMLHttpRequest()
            // xhttp.onreadystatechange = function() {
                  if (response.status == 200) {
                        // var arr = JSON.parse(this.responseText)
                        // console.log(arr)
                        if (arr.result === "ok") {
                              self.setState({ requestinfos: arr.data, requestinfofilter: arr.data, arrCount: arr.cnt }, () => {})

                              var State = [{ value: "0", label: "همه  کاربران" }]
                              var State2 = [{ value: "0", label: "همه رشته ها" }]
                              var State3 = [{ value: "0", label: "همه وضعیت ها" }]
                              for (var k = 0; k < arr.data.length; k++) {
                                    var toFind = arr.data[k].user_id
                                    var filtered = State.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State.push({
                                                value: arr.data[k].user_id,
                                                label: arr.data[k].user_name + " " + arr.data[k].user_family + " " + arr.data[k].user_mobile,
                                          })
                                    }

                                    toFind = arr.data[k].fieldinsurance_id
                                    filtered = State2.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State2.push({ value: arr.data[k].fieldinsurance_id, label: arr.data[k].request_fieldinsurance_fa })
                                    }

                                    toFind = arr.data[k].request_last_state_id
                                    filtered = State3.filter(function(el) {
                                          return el.value === toFind
                                    })
                                    if (filtered.length === 0) {
                                          State3.push({ value: arr.data[k].request_last_state_id, label: arr.data[k].request_last_state_name })
                                    }
                              }
                              self.setState({ optionSelectUser: State, selectedSelectUser: State[0] })
                              self.setState({ optionFieldInsurance: State2, selectedFieldInsurance: State2[0] })
                              self.setState({ optionStatusRequest: State3, selectedStatusRequest: State3[0] })
                        } else if (arr.result === "error") {
                        }
                        self.props.props.props.dispatch({
                              type: "WITEHIDE",
                        })
                  }
            // }
            // var fd = new FormData()
            // fd.append("command", "get_instalment_deficit")
            // fd.append("report_mode", "deficit_notpass")
            // fd.append("limit", rowsPerPage)
            // fd.append("offset", page * rowsPerPage)

            // xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`)
            // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
            // xhttp.send(fd)
      }
// -------------------------------------------------------------------------------------------------
    async  saveFinancialDocCode (instalment_check_id) {
            const { checkDatePass, checkDocPass, RefundUser } = this.state
            if (checkDatePass === "" || checkDocPass === "") {
                  this.setState({ snackstr: "لطفا تاریخ پاس شدن چک را انتخاب کنید", showSnack: true, snackMode: "error" })
            } else {
                  this.props.props.props.dispatch({
                        type: "WAITSHOW",
                  })

                  const response = await $post(`reportinstallmentpay?command=instalment_deficit_pass&instalment_check_id=${RefundUser["instalment_check_id"]}&
                  instalment_check_date_pass=${   "instalment_check_date_pass"},
                  Moment(JDate.toGregorian(checkDatePass.year, checkDatePass.month, checkDatePass.day)).format("YYYY-MM-DD h:mm:ss")}&
                  instalment_check_doc=${checkDocPass}
                  `, {
                        Authorization: this.cookies.get("employee_token_str"),
                      });
                
                      const arr = response.data;
                  var self = this
                  // var xhttp = new XMLHttpRequest()
                  // xhttp.onreadystatechange = function() {
                        if (response.status == 200) {
                              // var arr = JSON.parse(this.responseText)
                              if (arr.result === "ok") {
                                    self.getFinancialDocPaing()
                                    self.newFinancialDoc()
                              } else if (arr.result === "error") {
                                    this.setState({ snackstr: arr.desc, showSnack: true, snackMode: "error" })
                              }
                              self.props.props.props.dispatch({
                                    type: "WITEHIDE",
                              })
                        }
                  // }
                  // var fd = new FormData()
                  // fd.append("command", "instalment_deficit_pass")
                  // fd.append("instalment_check_id", RefundUser["instalment_check_id"])
                  // fd.append(
                  //       "instalment_check_date_pass",
                  //       Moment(JDate.toGregorian(checkDatePass.year, checkDatePass.month, checkDatePass.day)).format("YYYY-MM-DD h:mm:ss")
                  // )
                  // fd.append("instalment_check_doc", checkDocPass)

                  // xhttp.open("POST", `${constants.BASE_URL}/reportinstallmentpay`)
                  // xhttp.setRequestHeader("Authorization", this.cookies.get("employee_token_str"))
                  // xhttp.send(fd)
            }
      }




      handleFieldInsurance = (selectedFieldInsurance) => {
            this.setState({ selectedFieldInsurance: selectedFieldInsurance }, () => {
                  this.filterList()
            })
      }

      handleStatusRequest = (selectedStatusRequest) => {
            this.setState({ selectedStatusRequest: selectedStatusRequest }, () => {
                  this.filterList()
            })
      }

      handleSelectUser = (selectedSelectUser) => {
            this.setState({ selectedSelectUser: selectedSelectUser }, () => {
                  this.filterList()
            })
      }

      filterList = () => {
            const {
                  refundUserMaxAmount,
                  requestIdFilter,
                  refundUserMinAmount,
                  requestinfos,
                  selectedFieldInsurance,
                  selectedStatusRequest,
                  selectedSelectUser,
                  refundUserMinDate,
                  refundUserMaxDate,
                  refundPayMinDate,
                  refundPayMaxDate,
            } = this.state

            var timeStampMax = parseInt(
                  Moment(JDate.toGregorian(refundUserMaxDate.year, refundUserMaxDate.month, refundUserMaxDate.day)).format("x"),
                  0
            )
            var timeStampMin = parseInt(
                  Moment(JDate.toGregorian(refundUserMinDate.year, refundUserMinDate.month, refundUserMinDate.day)).format("x"),
                  0
            )
            var timeStampPayMax = parseInt(
                  Moment(JDate.toGregorian(refundPayMaxDate.year, refundPayMaxDate.month, refundPayMaxDate.day)).format("x"),
                  0
            )
            var timeStampPayMin = parseInt(
                  Moment(JDate.toGregorian(refundPayMinDate.year, refundPayMinDate.month, refundPayMinDate.day)).format("x"),
                  0
            )

            var i, temparray, temparray2, staterequest_last_timestamp, instalment_check_date
            temparray = requestinfos
            temparray2 = []
            for (i = 0; i < temparray.length; i++) {
                  staterequest_last_timestamp = parseInt(Moment(temparray[i].staterequest_last_timestamp, "YYYY-M-D HH:mm:ss").format("x"))
                  instalment_check_date = parseInt(Moment(temparray[i].instalment_check_date, "YYYY-M-D HH:mm:ss").format("x"))

                  if (
                        (temparray[i].fieldinsurance_id === selectedFieldInsurance.value || selectedFieldInsurance.value === "0") &&
                        (temparray[i].request_last_state_id === selectedStatusRequest.value || selectedStatusRequest.value === "0") &&
                        (temparray[i].user_id === selectedSelectUser.value || selectedSelectUser.value === "0") &&
                        (staterequest_last_timestamp > timeStampMin || !timeStampMin) &&
                        (staterequest_last_timestamp < timeStampMax || !timeStampMax) &&
                        (instalment_check_date > timeStampPayMin || !timeStampPayMin) &&
                        (instalment_check_date < timeStampPayMax || !timeStampPayMax) &&
                        ((requestIdFilter !== "" && temparray[i].request_id === requestIdFilter) || requestIdFilter === "") &&
                        (parseInt(refundUserMinAmount) <= parseInt(temparray[i].instalment_check_amount) || refundUserMinAmount === "") &&
                        (parseInt(refundUserMaxAmount) > parseInt(temparray[i].instalment_check_amount) || refundUserMaxAmount === "")
                  ) {
                        temparray2.push(temparray[i])
                  }
            }
            this.setState({ requestinfofilter: temparray2 }, () => {})
      }

      createSortHandler = (field) => {
            if (this.state.orderBy === field) {
                  if (this.state.order === "asc") {
                        this.setState({ order: "desc" })
                  } else {
                        this.setState({ order: "asc" })
                  }
            } else {
                  this.setState({ orderBy: field, order: "asc" })
            }
            var arraytemp = [],
                  i,
                  j,
                  temp,
                  a,
                  b
            arraytemp = this.state.requestinfofilter
            for (i = 0; i < arraytemp.length; i++) {
                  for (j = 0; j < arraytemp.length - 1; j++) {
                        a = arraytemp[j]
                        b = arraytemp[j + 1]
                        if (a[field] < b[field] && this.state.order === "asc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        } else if (a[field] > b[field] && this.state.order === "desc") {
                              temp = arraytemp[j]
                              arraytemp[j] = arraytemp[j + 1]
                              arraytemp[j + 1] = temp
                        }
                  }
            }
      }

      handleChangeRowsPerPage = (event) => {
            this.setState({ rowsPerPage: parseInt(event.target.value), page: 0 }, () => {
                  this.getFinancialDocPaing()
            })
      }

      handleChangePage = (event, number) => {
            this.setState({ page: parseInt(number, 0) }, () => {
                  this.getFinancialDocPaing()
            })
      }

      setImageModel = (image, largimage, desc) => {
            this.setState({
                  urlToLargeImageFile: largimage,
                  urlToHugeImageFile: image,
                  descImageFile: desc,
                  openImageBox: true,
            })
      }

      closeLightbox = () => {
            this.setState({
                  openImageBox: false,
            })
      }

      renderCustomInputMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ درخواست"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMaxDate.year
                              ? this.state.refundUserMaxDate.year + "/" + this.state.refundUserMaxDate.month + "/" + this.state.refundUserMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ درخواست"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundUserMinDate.year
                              ? this.state.refundUserMinDate.year + "/" + this.state.refundUserMinDate.month + "/" + this.state.refundUserMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputDatePass = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ تعهد"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.checkDatePass.year
                              ? this.state.checkDatePass.year + "/" + this.state.checkDatePass.month + "/" + this.state.checkDatePass.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearDatePass}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMax = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ تعهد"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMaxDate.year
                              ? this.state.refundPayMaxDate.year + "/" + this.state.refundPayMaxDate.month + "/" + this.state.refundPayMaxDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMax}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      renderCustomInputPayMin = ({ ref }) => (
            <OutlinedInput
                  readOnly
                  ref={ref} // necessary
                  placeholder="انتخاب تاریخ پاس شدن"
                  style={{
                        fontSize: "13px",
                        direction: "ltr",
                  }}
                  value={
                        this.state.refundPayMinDate.year
                              ? this.state.refundPayMinDate.year + "/" + this.state.refundPayMinDate.month + "/" + this.state.refundPayMinDate.day
                              : ""
                  }
                  className="my-custom-input-class" // a styling class
                  endAdornment={
                        <InputAdornment position="end">
                              <IconButton onClick={this.clearPayDeyMin}>
                                    <HighlightOffIcon />
                              </IconButton>
                        </InputAdornment>
                  }
            />
      )

      render() {
            const { classes } = this.props
            const {
                  checkDocPass,
                  newFinancialDoc,
                  requestIdFilter,
                  refundUserMaxDate,
                  refundUserMinDate,
                  checkDatePass,
                  refundPayMaxDate,
                  refundPayMinDate,
                  refundUserMaxAmount,
                  refundUserMinAmount,
                  optionFieldInsurance,
                  selectedFieldInsurance,
                  optionStatusRequest,
                  selectedStatusRequest,
                  optionSelectUser,
                  selectedSelectUser,
                  RefundUser,
                  snackMode,
                  snackstr,
                  showSnack,
                  order,
                  orderBy,
                  okstatus,
                  errstr,
                  redirect,
                  requestinfofilter,
                  rowsPerPage,
                  page,
                  arrCount,
                  urlToHugeImageFile,
                  descImageFile,
                  urlToLargeImageFile,
            } = this.state
            if (redirect) {
                  return <Redirect to="/" />
            } else {
                  return (
                        <div className={classes.paperrtl} dir="ltr">
                              <Snackbar
                                    anchorOrigin={{ vertical: "bottom", horizontal: "left" }}
                                    onClose={this.handleClickcloseTasckBar}
                                    open={showSnack}
                                    autoHideDuration={10000}
                              >
                                    <Alert severity={snackMode}>{snackstr}</Alert>
                              </Snackbar>
                              <Grid container spacing={3}>
                                    <Grid item xs={12}>
                                          <Container component="main" maxWidth="lg">
                                                <Paper elevation={4} className={classes.root}>
                                                      <Grid container spacing={3}>
                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMin} // render a custom input
                                                                                    value={refundUserMinDate}
                                                                                    onChange={this.setSelectedDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ درخواست  تا"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputMax} // render a custom input
                                                                                    value={refundUserMaxDate}
                                                                                    onChange={this.setSelectedDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ تعهد از"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMin} // render a custom input
                                                                                    value={refundPayMinDate}
                                                                                    onChange={this.setSelectedPayDayMin}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={3}>
                                                                  <div style={{ width: "100%", textAlign: "center" }}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ تعهد  تا"}
                                                                              <Calendar
                                                                                    renderInput={this.renderCustomInputPayMax} // render a custom input
                                                                                    value={refundPayMaxDate}
                                                                                    onChange={this.setSelectedPayDayMax}
                                                                                    locale="fa"
                                                                                    shouldHighlightWeekends
                                                                              />
                                                                        </Typography>
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداقل مبلغ"
                                                                        handleInputt={this.handleChangeMinAmount}
                                                                        value={refundUserMinAmount}
                                                                  />
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <FloatingLabelInput
                                                                        type="currency"
                                                                        placeholder="حداکثر مبلغ"
                                                                        handleInputt={this.handleChangeMaxAmount}
                                                                        value={refundUserMaxAmount}
                                                                  />
                                                            </Grid>
                                                            <Grid sm={4}>
                                                                  <FloatingLabelInput
                                                                        placeholder="شماره سفارش"
                                                                        value={requestIdFilter}
                                                                        handleInputt={this.handleChangeFilterRequestId}
                                                                  />
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">نوع کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={" نام کاربر"}
                                                                              value={selectedSelectUser}
                                                                              onChange={this.handleSelectUser}
                                                                              options={optionSelectUser}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">کاربر</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"کاربر"}
                                                                              value={selectedFieldInsurance}
                                                                              onChange={this.handleFieldInsurance}
                                                                              options={optionFieldInsurance}
                                                                        />
                                                                  </div>
                                                            </Grid>

                                                            <Grid item xs={4}>
                                                                  <div>
                                                                        <label className="on">وضعیت درخواست</label>
                                                                        <Select
                                                                              isSearchable={true}
                                                                              className="adapter-txtsize"
                                                                              placeholder={"وضعیت درخواست"}
                                                                              value={selectedStatusRequest}
                                                                              onChange={this.handleStatusRequest}
                                                                              options={optionStatusRequest}
                                                                        />
                                                                  </div>
                                                            </Grid>
                                                      </Grid>
                                                </Paper>
                                          </Container>
                                    </Grid>

                                    <Grid item xs={12}>
                                          {newFinancialDoc || RefundUser === null ? null : (
                                                <Container component="main" maxWidth="lg">
                                                      <Paper elevation={4} className={classes.root}>
                                                            <Grid container spacing={3}>
                                                                  <Grid item xs={12}>
                                                                        <Typography variant="h6">{"سند مالی در حال تعهد"}</Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شماره سند:  " + RefundUser["instalment_check_id"]}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"مبلغ چک:  "}
                                                                              <NumberFormat
                                                                                    displayType={"text"}
                                                                                    value={RefundUser["instalment_check_amount"]}
                                                                                    thousandSeparator={true}
                                                                                    prefix={" ریال"}
                                                                              />
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={2}>
                                                                        <Typography align="center" variant="h7">
                                                                              {" شماره چک:  " + RefundUser["instalment_check_num"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={4}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام کاربر:  " +
                                                                                    RefundUser["user_name"] +
                                                                                    " " +
                                                                                    RefundUser["user_family"] +
                                                                                    " -همراه:" +
                                                                                    RefundUser["user_mobile"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"نام نماینده:  " +
                                                                                    RefundUser["agent_name"] +
                                                                                    " " +
                                                                                    RefundUser["agent_family"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {" رشته بیمه:" + RefundUser["request_fieldinsurance_fa"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography align="center" variant="h7">
                                                                              {"شرکت بیمه:" + RefundUser["company_name"]}
                                                                        </Typography>
                                                                  </Grid>

                                                                  <Grid item xs={3}>
                                                                        <Typography variant="h7">
                                                                              {"تاریخ چک: "}
                                                                              {RefundUser["instalment_check_date"]
                                                                                    ? new JDate(
                                                                                            new Date(
                                                                                                  parseInt(
                                                                                                        Moment(
                                                                                                              RefundUser["instalment_check_date"],
                                                                                                              "YYYY-M-D HH:mm:ss"
                                                                                                        ).format("x")
                                                                                                  )
                                                                                            )
                                                                                      ).format("YYYY/MM/DD")
                                                                                    : ""}
                                                                        </Typography>
                                                                  </Grid>
                                                                  <Grid item xs={3}>
                                                                        <Avatar
                                                                              variant="rounded"
                                                                              alt="Remy Sharp"
                                                                              src={RefundUser["instalment_check_image_turl"]}
                                                                              onClick={() => {
                                                                                    this.setImageModel(
                                                                                          RefundUser["instalment_check_image_turl"],
                                                                                          RefundUser["instalment_check_image_url"],
                                                                                          "عکس چک های سفارش "
                                                                                    )
                                                                              }}
                                                                        />{" "}
                                                                  </Grid>
                                                                  <Grid item xs={12}>
                                                                        <Divider />
                                                                  </Grid>

                                                                  <Grid item xs={6}>
                                                                        <Calendar
                                                                              renderInput={this.renderCustomInputDatePass} // render a custom input
                                                                              value={checkDatePass}
                                                                              onChange={this.setSelectedDatePass}
                                                                              locale="fa"
                                                                              shouldHighlightWeekends
                                                                        />
                                                                  </Grid>
                                                                  <Grid item xs={6}>
                                                                        <FloatingLabelInput
                                                                              placeholder="توضیحات سند"
                                                                              value={checkDocPass}
                                                                              handleInputt={this.handleDocPass}
                                                                        />
                                                                  </Grid>

                                                                  <Grid item xs={12}>
                                                                        <div style={{ width: "100%", textAlign: "right" }}>
                                                                              <Button
                                                                                    variant="outlined"
                                                                                    color="primary"
                                                                                    onClick={this.saveFinancialDocCode}
                                                                              >
                                                                                    {"ثبت  تاریخ پاس شدن"}
                                                                              </Button>
                                                                        </div>
                                                                  </Grid>
                                                            </Grid>

                                                            <Grid item xs={12}>
                                                                  <div style={{ width: "100%", textAlign: "left" }}>
                                                                        <Button variant="outlined" color="primary" onClick={this.newFinancialDoc}>
                                                                              {"بستن"}
                                                                        </Button>
                                                                  </div>
                                                            </Grid>
                                                      </Paper>
                                                </Container>
                                          )}
                                    </Grid>

                                    <Grid item xs={12}>
                                          <Container maxWidth="lg">
                                                <Paper className={classes.root}>
                                                      <ReactHTMLTableToExcel
                                                            id="test-table-xls-button"
                                                            className="download-table-xls-button"
                                                            table="table-to-xls"
                                                            filename="tablexls"
                                                            sheet="tablexls"
                                                            buttonText="Download as XLS"
                                                      />

                                                      <TableContainer dir="rtl">
                                                            <Table id="table-to-xls" aria-label="sticky table">
                                                                  <TableHead>
                                                                        <TableRow>
                                                                              <TableCell
                                                                                    key={"instalment_check_id"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 20 }}
                                                                                    sortDirection={orderBy === "instalment_check_id" ? order : false}
                                                                              >
                                                                                    {"آیدی سند"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_check_id"}
                                                                                          direction={
                                                                                                orderBy === "instalment_check_id" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_check_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"user_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"آی دی کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_id"}
                                                                                          direction={orderBy === "user_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell key={"user_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_name"}
                                                                                          direction={orderBy === "user_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"user_mobile"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"همراه کاربر"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "user_mobile"}
                                                                                          direction={orderBy === "user_mobile" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("user_mobile")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"instalment_check_amount"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"مبلغ"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_check_amount"}
                                                                                          direction={
                                                                                                orderBy === "instalment_check_amount" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_check_amount")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"instalment_check_date"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ چک"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "instalment_check_date"}
                                                                                          direction={
                                                                                                orderBy === "instalment_check_date" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("instalment_check_date")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"organ_name"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"نام ارگان"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_name"}
                                                                                          direction={orderBy === "organ_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_contract_num"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شماره قرارداد"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_contract_num"}
                                                                                          direction={orderBy === "organ_contract_num" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_contract_num")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"organ_user_personal_code"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"کد پرسنلی"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "organ_user_personal_code"}
                                                                                          direction={
                                                                                                orderBy === "organ_user_personal_code" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("organ_user_personal_code")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell key={"request_id"} align={"center"} style={{ minWidth: 60 }}>
                                                                                    {"شماره درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_id"}
                                                                                          direction={orderBy === "request_id" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_id")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_fieldinsurance_fa"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"رشته بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_fieldinsurance_fa"}
                                                                                          direction={
                                                                                                orderBy === "request_fieldinsurance_fa"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_fieldinsurance_fa")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"company_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"شرکت بیمه"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "company_name"}
                                                                                          direction={orderBy === "company_name" ? order : "asc"}
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("company_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>

                                                                              <TableCell
                                                                                    key={"request_last_state_name"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"وضعیت درخواست"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "request_last_state_name"}
                                                                                          direction={
                                                                                                orderBy === "request_last_state_name" ? order : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("request_last_state_name")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                              <TableCell
                                                                                    key={"staterequest_last_timestamp"}
                                                                                    align={"center"}
                                                                                    style={{ minWidth: 60 }}
                                                                              >
                                                                                    {"تاریخ آخرین وضعیت"}
                                                                                    <TableSortLabel
                                                                                          active={orderBy === "staterequest_last_timestamp"}
                                                                                          direction={
                                                                                                orderBy === "staterequest_last_timestamp"
                                                                                                      ? order
                                                                                                      : "asc"
                                                                                          }
                                                                                          onClick={(e) => {
                                                                                                this.createSortHandler("staterequest_last_timestamp")
                                                                                          }}
                                                                                    ></TableSortLabel>
                                                                              </TableCell>
                                                                        </TableRow>
                                                                  </TableHead>

                                                                  <TableBody>
                                                                        {requestinfofilter.slice(0, rowsPerPage).map((row) => {
                                                                              return (
                                                                                    <TableRow
                                                                                          hover
                                                                                          role="checkbox"
                                                                                          tabIndex={-1}
                                                                                          key={row["instalment_check_id"]}
                                                                                          value={row}
                                                                                          onClick={() => {
                                                                                                this.handleSelectRows(row)
                                                                                          }}
                                                                                    >
                                                                                          <TableCell key={"instalment_check_id"} align={"center"}>
                                                                                                {row["instalment_check_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_id"} align={"center"}>
                                                                                                {row["user_id"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_name"} align={"center"}>
                                                                                                {row["user_name"] + " " + row["user_family"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"user_mobile"} align={"center"}>
                                                                                                {row["user_mobile"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"instalment_check_amount"} align={"center"}>
                                                                                                <NumberFormat
                                                                                                      displayType={"text"}
                                                                                                      value={row["instalment_check_amount"]}
                                                                                                      thousandSeparator={true}
                                                                                                      prefix={" ریال"}
                                                                                                />
                                                                                          </TableCell>

                                                                                          <TableCell key={"instalment_check_date"} align={"center"}>
                                                                                                {row["instalment_check_date"]
                                                                                                      ? new JDate(
                                                                                                              new Date(
                                                                                                                    parseInt(
                                                                                                                          Moment(
                                                                                                                                row[
                                                                                                                                      "instalment_check_date"
                                                                                                                                ],
                                                                                                                                "YYYY-M-D HH:mm:ss"
                                                                                                                          ).format("x")
                                                                                                                    )
                                                                                                              )
                                                                                                        ).format("YYYY/MM/DD")
                                                                                                      : ""}
                                                                                          </TableCell>

                                                                                          <TableCell key={"organ_name"} align={"center"}>
                                                                                                {row["organ_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"organ_contract_num"} align={"center"}>
                                                                                                {row["organ_contract_num"]}
                                                                                          </TableCell>

                                                                                          <TableCell
                                                                                                key={"organ_user_personal_code"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["organ_user_personal_code"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"request_id"} align={"center"}>
                                                                                                {row["request_id"]}
                                                                                          </TableCell>
                                                                                          <TableCell
                                                                                                key={"request_fieldinsurance_fa"}
                                                                                                align={"center"}
                                                                                          >
                                                                                                {row["request_fieldinsurance_fa"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"company_name"} align={"center"}>
                                                                                                {row["company_name"]}
                                                                                          </TableCell>

                                                                                          <TableCell key={"request_last_state_name"} align={"center"}>
                                                                                                {row["request_last_state_name"]}
                                                                                          </TableCell>
                                                                                          <TableCell key={"instalment_check_amount"} align={"center"}>
                                                                                                {new JDate(
                                                                                                      new Date(
                                                                                                            parseInt(
                                                                                                                  Moment(
                                                                                                                        row[
                                                                                                                              "staterequest_last_timestamp"
                                                                                                                        ],
                                                                                                                        "YYYY-M-D HH:mm:ss"
                                                                                                                  ).format("x")
                                                                                                            )
                                                                                                      )
                                                                                                ).format("YYYY/MM/DD") +
                                                                                                      " " +
                                                                                                      Moment(
                                                                                                            row["staterequest_last_timestamp"],
                                                                                                            "YYYY-M-D HH:mm:ss"
                                                                                                      ).format("HH:mm:ss")}
                                                                                          </TableCell>
                                                                                    </TableRow>
                                                                              )
                                                                        })}
                                                                  </TableBody>
                                                            </Table>
                                                      </TableContainer>
                                                      <TablePagination
                                                            rowsPerPageOptions={[10, 25, 100, 1000, 5000, 10000, 100000]}
                                                            component="div"
                                                            count={arrCount}
                                                            rowsPerPage={rowsPerPage}
                                                            page={page}
                                                            onChangePage={this.handleChangePage}
                                                            onChangeRowsPerPage={this.handleChangeRowsPerPage}
                                                      />
                                                </Paper>
                                                {this.state.openImageBox && (
                                                      <Lightbox
                                                            medium={urlToLargeImageFile}
                                                            large={urlToHugeImageFile}
                                                            alt={descImageFile}
                                                            onClose={this.closeLightbox}
                                                            showRotate={true}
                                                            hideZoom={false}
                                                      />
                                                )}
                                          </Container>
                                    </Grid>
                              </Grid>

                              {okstatus ? (
                                    <Alert severity="success">
                                          <AlertTitle>پیام</AlertTitle>
                                          {errstr}
                                    </Alert>
                              ) : null}
                        </div>
                  )
            }
      }
}

export default withStyles(styles)(ChangeReportInstalmentDificitNoPassed)
